import { useContext } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import CheckUpContext from "../../context/check-up";
import UserContext from "../../context/user";
import {
  computeCheckUpPartial,
  getBinaryAnswer,
  getGenderAnswer,
  parseRequest,
} from "../../utils/check-up";

const useCheckUpUpdateMutation = (closeModal, nextSectionIndex) => {
  const { callApi, userProfile } = useContext(UserContext);
  const { setRequests, handleNext, setFormData, setCurrentRequest, setNavigation } =
    useContext(CheckUpContext);
  const queryClient = useQueryClient();

  return useMutation(
    ({
      survey,
      request,
      formData,
      values,
      email,
      phone,
      gender,
      dateOfBirth,
      workplace,
      birthPlace,
      taxCode,
      preferredTimeSlot,
      quadro,
      manager,
      packageSelected,
      clinicId,
      lastCompletedStep,
    }) =>
      callApi(`/checkUp/request/${request?.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: request.id,
          ...(email ? { welfareEmail: email } : {}),
          ...(phone ? { welfarePhone: phone } : {}),
          ...(gender ? { gender: getGenderAnswer(survey, gender) } : {}),
          ...(dateOfBirth ? { dateOfBirth } : {}),
          ...(workplace ? { workplace } : {}),
          ...(birthPlace ? { birthPlace } : {}),
          ...(taxCode ? { taxCode } : {}),
          ...(preferredTimeSlot ? { preferredTimeSlot } : {}),
          ...(quadro ? { quadro: getBinaryAnswer(survey, "quadro", quadro) } : {}),
          ...(manager ? { manager: getBinaryAnswer(survey, "manager", manager) } : {}),
          ...(packageSelected ? { packageSelected } : {}),
          ...(clinicId ? { clinicId } : {}),
          ...(typeof lastCompletedStep === "number" ? { lastCompletedStep } : {}),
          surveyAnswer: {
            ...computeCheckUpPartial(survey, { ...formData, ...values }),
          },
        }),
      }),
    {
      onSuccess: (data, variables) => {
        if (data?.id) {
          setFormData((current) => ({ ...current, ...variables.values }));
          setRequests((current) =>
            current.map((request) => (request.id === data.id ? parseRequest(data) : request))
          );
          setCurrentRequest(parseRequest(data));
          if (closeModal) {
            closeModal();
            setCurrentRequest();
            setNavigation();
            queryClient.invalidateQueries(["requests", JSON.stringify(userProfile)]);
          } else {
            handleNext(data?.id, nextSectionIndex);
          }
        }
      },
    }
  );
};

export default useCheckUpUpdateMutation;
